import component from './CreateCartItemsTable.vue'
export default component
